import { GameStates } from "onearm";
import { SubGameState } from "./SubGameState";
import gsap from "gsap";

export class FreespinIntro extends SubGameState {
    enter() {
        super.enter();
        this.startFreeSpins();
    }

    wait(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async startFreeSpins() {
        if (this.gameLogic.hasFreeSpins()) {
            const freeSpins = this.gameLogic.nextFreeSpins();

            await this.wait(500);

            const transitionScene = this.scenes.add("TransitionScene", {layer: "popups", screen: this.screen});
            const freeSpinIntroPopup = this.scenes.add("FreeSpinIntroPopup", { screen: this.screen, freeSpins });

            const tl = gsap.timeline();
            tl.playSfx("freespin_transition");
            tl.add(transitionScene.transition());
            tl.add(() => this.scenes.remove("TransitionScene"));
            tl.add(() => {
                this.gameState.setFreeSpinsMode();
                this.showFreeSpinsCounter();
            }, 0.25);

            tl.add(this.hud.toFreeSpinsModeAnimation());
            tl.add(() => {
                this.audio.stopMusic("basegame_loop");
                this.audio.playSfx("transition");
            });
            this.audio.playMusic("bg_music_1", { loop: true });

            tl.add(freeSpinIntroPopup.show());
            tl.add("skipScreen", "-=0.25");
            tl.add(() => {
                this.audio.stopMusic("bg_music_1");
                this.audio.playMusic("freegame_loop", { loop: true });
                this.gameState.goTo(GameStates.FREE_SPIN_SPINNING);
            });

           freeSpinIntroPopup.interactive = true;
           freeSpinIntroPopup.interactiveChildren = true;
           freeSpinIntroPopup.eventMode = "static";

           freeSpinIntroPopup.on("pointerdown", () => {
            tl.seek("skipScreen");
            freeSpinIntroPopup.interactive = false;
            freeSpinIntroPopup.interactiveChildren = false;
            freeSpinIntroPopup.eventMode = "none";
           });
        } else {
            this.gameState.goTo(GameStates.IDLE);
        }
    }

    exit() {
        const freeSpins = this.gameLogic.getCurrentFreeSpins();

        this.autoplay.start({
            gamesLimit: freeSpins.left,
        });

        this.scenes.remove("FreeSpinIntroPopup");
        this.scenes.remove("TransitionScene");
    }

    showFreeSpinsCounter() {
        this.hud.showWinInfo({ win: this.gameLogic.getFreeSpinsTotalWin() });
        this.hud.setFreeSpinsState();
        this.hud.setFreeSpinsCounter(this.gameLogic.getCurrentFreeSpins());
        this.hud.setPaysText("FREE SPINS STARTED!");
    }
}
